












































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Getter, Action, Mutation } from 'vuex-class'
import { EntityId, Counterexamples, Implication,
         ExplorationResult, GameConfiguration } from '~/api/types'
import { getNumberOfCounterexamples, getSupport } from '~/api/index'
import ImplicationVue from '~/components/Implication.vue'
import CounterexampleVue from '~/components/Counterexample.vue'
import TegSetup from '~/components/TegSetup.vue'

@Component({
  components: {
    'implication': ImplicationVue,
    'counterexample': CounterexampleVue,
    'teg-setup': TegSetup,
  },
})
export default class TegGame extends Vue {
  @Getter private getMaxCounterexamples!: number
  @Getter private getProperties!: EntityId[]
  @Getter private getCounterexamples!: Counterexamples
  @Getter private getImplications!: Implication[]
  @Getter private getCandidateImplication!: Implication | null
  @Getter private getCandidateCounterexamples!: Counterexamples | null
  @Getter private getSessionId!: string | null
  @Action private newGame!: (configuration: GameConfiguration) => Promise<ExplorationResult>
  @Action private acceptImplication!: () => Promise<ExplorationResult>
  @Action private acceptCounterexamples!: () => Promise<ExplorationResult>
  @Mutation private rejectCounterexample!: (itemId: EntityId) => void
  @Mutation private addCounterexamples!: (counterexamples: Counterexamples) => void

  private support: number = 0
  private counter: number = 0
  private numCounterExamples = 0
  private implication: Implication | null = null
  private playing = false

  @Watch('implication')
  private async onCandidateChanged() {
    if (!this.implication) {
      this.numCounterExamples = 0
      this.support = 0
    } else {
      const num = await getNumberOfCounterexamples(this.implication,
                                                   this.getSessionId || '')
      const sup = await getSupport(this.implication)
      this.numCounterExamples = num
      this.support = sup
    }
  }

  private get candidateCounterexamples() {
    const candidates = this.getCandidateCounterexamples || {}

    return Object.entries(candidates)
  }

  private get won() {
    this.implication = this.getCandidateImplication

    return this.implication && !this.implication.head.length && !this.implication.body.length
  }

  private onStartGame(event: any) {
    this.newGame(event)
    this.playing = true
  }

  private onAccept() {
    this.acceptImplication()
  }

  private onReject() {
    this.implication = this.getCandidateImplication || { head: [], body: [] }
    const counters = this.candidateCounterexamples || []

    if (!counters.length) {
      ++this.counter
      const item = `artificial-counterexample-${this.counter}`
      const counterexample: Counterexamples = { [item]: this.implication.body }
      this.addCounterexamples(counterexample)
    }

    this.acceptCounterexamples()
  }
}
